import { SidenavSection, SUBSET_MATCH_OPTIONS } from "../../parts/sidenav-nav.model";

/**
 * Developer admin menu, rendered by `app-sidenav-group` inside the home view.
 * Add / remove / reorder items by editing this array — no markup changes needed.
 * Items route under the `developer` segment, except sales orders (`sales-order`, guarded by developerGuard).
 */
export const DEVELOPER_SECTIONS: SidenavSection[] = [
    {
        id: "quote-ops",
        subheadingKey: "ADMIN.DEVELOPER.GROUPS.QUOTE_OPS",
        items: [
            { labelKey: "HEADER.ALL_SALES_ORDERS", icon: "shopping-cart", segments: ["sales-order"], routerLinkActiveOptions: SUBSET_MATCH_OPTIONS },
            { labelKey: "ADMIN.DEVELOPER.TRANSFER_QUOTES", icon: "arrows-h", segments: ["developer", "transfer-quotes"] },
            { labelKey: "ADMIN.DEVELOPER.AUTO_ARCHIVE", icon: "clock", segments: ["developer", "auto-archive"] },
            { labelKey: "ADMIN.DEVELOPER.ATTIO_MIGRATION", icon: "cloud-upload", segments: ["developer", "attio-migration"] },
        ],
    },
    {
        id: "communications",
        subheadingKey: "ADMIN.DEVELOPER.GROUPS.COMMUNICATIONS",
        items: [
            { labelKey: "ADMIN.DEVELOPER.NOTIFICATIONS", icon: "megaphone", segments: ["developer", "notifications"] },
            { labelKey: "ADMIN.DEVELOPER.MARKETING_AUTOMATION", icon: "envelope", segments: ["developer", "marketing-automation"] },
        ],
    },
    {
        id: "tools",
        subheadingKey: "ADMIN.DEVELOPER.GROUPS.TOOLS",
        items: [
            { labelKey: "ADMIN.DEVELOPER.TRANSLATIONS", icon: "language", segments: ["developer", "translations"] },
            { labelKey: "ADMIN.DEVELOPER.LOADER_PREVIEW", icon: "spinner", segments: ["developer", "loader-preview"] },
            { labelKey: "ADMIN.DEVELOPER.WEBHOOKS", icon: "link", segments: ["developer", "webhooks"] },
        ],
    },
];
